import { Box } from "@mui/system";
import { useRecordContext, useRedirect } from "react-admin";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";

type AddButtonProps = {
	resource: string;
	foreignKey: string;
	label: string;
};

export const AddButton = ({ resource, foreignKey, label }: AddButtonProps) => {
	const record = useRecordContext();

	const redirect = useRedirect();

	return (
		<Box mt={2} sx={{ display: "flex", justifyContent: "start" }}>
			<Button
				variant="contained"
				startIcon={<AddIcon />}
				onClick={() =>
					redirect(
						"create",
						resource,
						undefined,
						{},
						{
							record: {
								[foreignKey]: record.id,
							},
						}
					)
				}
			>
				{label}
			</Button>
		</Box>
	);
};
